module.exports = __webpack_public_path__ + "static/media/activationLoading.2b5b73ef.png";